import AbstractSponsorComment from '@ui/comments/comments-views/abstract-sponsor-comment';

export default class SponsorIplaComment extends AbstractSponsorComment {
    constructor() {
        super();
        this.type = 'ipla';
        this.data = {
            avatar: '/img/sponsors/canal-plus.png',
            name: 'CANAL+ online',
            text: '[sponsorowany]',
            linkText: 'CANAL+ online',
            comment: 'Ten mecz możesz obejrzeć w ',
            button: true,
            secondText: false,
        };
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comments-views/sponsor-ipla-comment.js